import { render, staticRenderFns } from "./UpdateTimelineItem.vue?vue&type=template&id=79d85bbe&scoped=true&"
import script from "./UpdateTimelineItem.vue?vue&type=script&lang=ts&"
export * from "./UpdateTimelineItem.vue?vue&type=script&lang=ts&"
import style0 from "./UpdateTimelineItem.vue?vue&type=style&index=0&id=79d85bbe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d85bbe",
  null
  
)

export default component.exports